import React, { useState } from "react";

import axios from "axios";

import {
  useNavigate,
  Link
} from "react-router-dom";

import Header from "../components/Header";

import config from "../config";

const API =
  `${config.API_BASE_URL}/api/auth/login`;

const Login = () => {

  const navigate =
    useNavigate();

  // =========================
  // STATES
  // =========================

  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [showPassword, setShowPassword] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  // =========================
  // LOGIN
  // =========================

  const handleLogin =
    async (e) => {

    e.preventDefault();

    setError("");

    try {

      setLoading(true);

      const res =
        await axios.post(
          API,
          {
            email,
            password
          }
        );

      // =========================
      // SAVE TOKEN
      // =========================

      localStorage.setItem(
        "token",
        res.data.token
      );

      localStorage.setItem(
        "user",
        JSON.stringify(
          res.data.user
        )
      );

      alert(
        "✅ Login successful"
      );

      // =========================
      // REDIRECT
      // =========================

      const role =
        (
          res.data.user.role ||
          ""
        ).toLowerCase();

      if (
        role === "admin"
      ) {

        navigate("/admin");

      } else {

        navigate("/");
      }

    } catch (err) {

      console.error(
        "LOGIN ERROR:",
        err
      );

      setError(
        err.response?.data?.message ||
        "Login failed"
      );

    } finally {

      setLoading(false);
    }
  };

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <Header />

      {/* LOGIN CONTAINER */}

      <div style={styles.container}>

        <div style={styles.card}>

          {/* TITLE */}

          <h1 style={styles.title}>
            🔐 Welcome Back
          </h1>

          <p style={styles.subtitle}>
            Login to continue shopping
          </p>

          {/* ERROR */}

          {error && (

            <div style={styles.error}>
              {error}
            </div>

          )}

          {/* FORM */}

          <form
            onSubmit={
              handleLogin
            }
          >

            {/* EMAIL */}

            <div style={styles.field}>

              <label style={styles.label}>
                Email Address
              </label>

              <input
                type="email"
                value={email}
                onChange={(e) =>
                  setEmail(
                    e.target.value
                  )
                }
                required
                placeholder="Enter your email"
                style={styles.input}
              />

            </div>

            {/* PASSWORD */}

            <div style={styles.field}>

              <label style={styles.label}>
                Password
              </label>

              <div
                style={
                  styles.passwordWrap
                }
              >

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  value={password}
                  onChange={(e) =>
                    setPassword(
                      e.target.value
                    )
                  }
                  required
                  placeholder="Enter password"
                  style={
                    styles.passwordInput
                  }
                />

                <button
                  type="button"
                  style={
                    styles.showBtn
                  }
                  onClick={() =>
                    setShowPassword(
                      !showPassword
                    )
                  }
                >
                  {showPassword
                    ? "🙈"
                    : "👁"}
                </button>

              </div>

            </div>

            {/* LOGIN BUTTON */}

            <button
              type="submit"
              disabled={loading}
              style={styles.button}
            >

              {loading
                ? "Logging in..."
                : "Login"}

            </button>

          </form>

          {/* REGISTER */}

          <div style={styles.footer}>

            Don’t have an account?

            <Link
              to="/register"
              style={styles.link}
            >
              Register
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Login;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(to right, #fff7e6, #ffe0cc)"
  },

  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    minHeight:
      "calc(100vh - 90px)"
  },

  card: {
    width: "100%",
    maxWidth: 420,
    background: "#fff",
    padding: 35,
    borderRadius: 20,
    boxShadow:
      "0 8px 25px rgba(0,0,0,0.1)"
  },

  title: {
    margin: 0,
    textAlign: "center",
    fontSize: 32,
    color: "#222"
  },

  subtitle: {
    textAlign: "center",
    color: "#666",
    marginTop: 10,
    marginBottom: 25
  },

  field: {
    marginBottom: 20
  },

  label: {
    display: "block",
    marginBottom: 8,
    fontWeight: "bold",
    color: "#333"
  },

  input: {
    width: "100%",
    padding: 14,
    border:
      "1px solid #ddd",
    borderRadius: 10,
    fontSize: 15,
    outline: "none",
    boxSizing: "border-box"
  },

  passwordWrap: {
    display: "flex",
    alignItems: "center",
    border:
      "1px solid #ddd",
    borderRadius: 10,
    overflow: "hidden",
    background: "#fff"
  },

  passwordInput: {
    flex: 1,
    padding: 14,
    border: "none",
    outline: "none",
    fontSize: 15
  },

  showBtn: {
    border: "none",
    background: "#fff",
    cursor: "pointer",
    padding: "0 14px",
    fontSize: 18
  },

  button: {
    width: "100%",
    padding: 14,
    border: "none",
    borderRadius: 10,
    background: "#ff9800",
    color: "#fff",
    fontWeight: "bold",
    fontSize: 16,
    cursor: "pointer",
    marginTop: 5
  },

  error: {
    background: "#ffe5e5",
    color: "#d8000c",
    padding: 12,
    borderRadius: 10,
    marginBottom: 20,
    fontSize: 14
  },

  footer: {
    marginTop: 25,
    textAlign: "center",
    color: "#555"
  },

  link: {
    marginLeft: 6,
    color: "#ff5722",
    fontWeight: "bold",
    textDecoration: "none"
  }
};